export function SparkColorfulIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M2.23907 0C3.47522 0 4.47813 1.20332 4.47813 2.68649V9.59859C4.47813 11.0818 3.47522 12.2851 2.23907 12.2851C1.00292 12.2851 0 11.0818 0 9.59859V2.68649C0 1.20332 1.00292 0 2.23907 0Z'
        fill='url(#paint0_linear_32425_30534)'
      />
      <path
        d='M8.00005 3.71484C9.2362 3.71484 10.2391 4.91817 10.2391 6.40133V13.3134C10.2391 14.7966 9.2362 15.9999 8.00005 15.9999C6.7639 15.9999 5.76099 14.7966 5.76099 13.3134V6.40133C5.76099 4.91817 6.7639 3.71484 8.00005 3.71484Z'
        fill='url(#paint1_linear_32425_30534)'
      />
      <path
        d='M13.7609 0.286865C14.9971 0.286865 16 1.49019 16 2.97335V12.446C16 13.9292 14.9971 15.1325 13.7609 15.1325C12.5248 15.1325 11.5219 13.9292 11.5219 12.446V2.97335C11.5219 1.49019 12.5248 0.286865 13.7609 0.286865Z'
        fill='url(#paint2_linear_32425_30534)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_32425_30534'
          x1='5.39942'
          y1='-2.8404'
          x2='-2.33028'
          y2='12.4323'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4C519E' />
          <stop offset='1' stopColor='#EA4A91' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_32425_30534'
          x1='11.1604'
          y1='0.867448'
          x2='3.43071'
          y2='16.1402'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4C519E' />
          <stop offset='1' stopColor='#5EB6E7' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_32425_30534'
          x1='16.274'
          y1='1.2873'
          x2='8.53643'
          y2='15.0213'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#EE724B' />
          <stop offset='1' stopColor='#FBBF47' />
        </linearGradient>
      </defs>
    </svg>
  )
}
